import "./ContentPage.css";

export default function ContentPage({ title, eyebrow = "Terry Land", hero, children }) {
  return (
    <article className="content-page">
      <div className="container content-page__inner">
        {hero && <div className="content-page__hero">{hero}</div>}
        <p className="section-label">{eyebrow}</p>
        <h1>{title}</h1>
        {children}
      </div>
    </article>
  );
}
